module.exports = __webpack_public_path__ + "media/workplace/rating-dull-fill-a1d0fa1b.svg";